import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { api } from '../../api';
import toast from 'react-hot-toast';

const AdminQuizPreview: React.FC = () => {
  const { quizId } = useParams();
  const navigate = useNavigate();
  const [quiz, setQuiz] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        const response = await api.get(`/quizzes/${quizId}/admin-preview`);
        setQuiz(response.data.data);
      } catch (error) {
        console.error('Error loading quiz:', error);
        toast.error('Erreur lors du chargement du quiz');
        navigate('/admin/quizzes');
      } finally {
        setLoading(false);
      }
    };

    fetchQuiz();
  }, [quizId, navigate]);

  if (loading) {
    return <Layout><div>Chargement...</div></Layout>;
  }

  if (!quiz) {
    return <Layout><div>Quiz non trouvé.</div></Layout>;
  }

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-gray-900">Aperçu du Quiz: {quiz.title}</h1>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <p className="text-gray-600 mb-4">{quiz.description}</p>
          {quiz.questions.map((question: any, index: number) => (
            <div key={question._id} className="mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Question {index + 1}: {question.text}</h3>
              <div className="space-y-2 mt-2">
                {question.options.map((option: any, optionIndex: number) => (
                  <div key={optionIndex} className="flex items-center">
                    <input type="radio" name={`question-${question._id}`} id={`option-${question._id}-${optionIndex}`} className="mr-2" />
                    <label htmlFor={`option-${question._id}-${optionIndex}`}>{option.text}</label>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default AdminQuizPreview;